const defaultState = {
  all_messages: {},
  unread_messages: {},
};

function initPeerObject(peerJid, updatedPeers, teamMessages) {
  if (!updatedPeers[peerJid]) {
    updatedPeers[peerJid] = [
      ...((teamMessages && teamMessages[peerJid]) || []),
    ];
  }
  return updatedPeers[peerJid];
}

export default ActionTypes => {
  return (state = defaultState, action) => {
    try {
      switch (action.type) {
        case ActionTypes.UPDATE_ALL_MESSAGES: {
          const { addedMessages, removedIds, ownerGuid } = action.payload;
          const messages =
            (state.all_messages && { ...state.all_messages[ownerGuid] }) || {};
          if (addedMessages)
            addedMessages.forEach(message => {
              messages[message.message_cache_id] = message;
            });
          if (removedIds)
            removedIds.forEach(messageCacheId => {
              delete messages[messageCacheId];
            });
          return {
            ...state,
            all_messages: { ...state.all_messages, [ownerGuid]: messages },
          };
        }

        case ActionTypes.UPDATE_UNREAD_MESSAGES: {
          const { messages, ownerGuid } = action.payload;
          const {
            unread_messages: { [ownerGuid]: teamMessages },
          } = state;
          const updatedPeers = {};

          messages.forEach(msg => {
            const {
              unread,
              peer: { jid: peerJid },
              isVisibleMessage,
              message_cache_id: mCId,
            } = msg;
            const isUnread = unread && isVisibleMessage;
            const idx =
              teamMessages && teamMessages[peerJid]
                ? teamMessages[peerJid].indexOf(mCId)
                : -1;
            if (isUnread) {
              if (idx === -1) {
                initPeerObject(peerJid, updatedPeers, teamMessages);
                updatedPeers[peerJid].push(mCId);
              }
            } else if (idx > -1) {
              const peerMsgs = initPeerObject(
                peerJid,
                updatedPeers,
                teamMessages
              );
              const updateIdx = peerMsgs.indexOf(mCId);
              if (idx > -1) {
                updatedPeers[peerJid] = [
                  ...peerMsgs.slice(0, updateIdx),
                  ...peerMsgs.slice(updateIdx + 1),
                ];
              }
            }
          });

          if (Object.keys(updatedPeers).length) {
            const updatedTeamMessages = {
              ...teamMessages,
              ...updatedPeers,
            };
            Object.keys(updatedPeers).forEach(peerJid => {
              if (updatedPeers[peerJid].length === 0) {
                delete updatedTeamMessages[peerJid];
              }
            });
            return {
              ...state,
              unread_messages: {
                ...state.unread_messages,
                [ownerGuid]: updatedTeamMessages,
              },
            };
          }
          return state;
        }
        case ActionTypes.DELETE_UNREAD_MESSAGE: {
          const { mCId, peerJid, ownerGuid } = action.payload;
          if (
            state.unread_messages[ownerGuid] &&
            state.unread_messages[ownerGuid][peerJid]
          ) {
            const peerMsgs = state.unread_messages[ownerGuid][peerJid];
            const idx = peerMsgs.indexOf(mCId);
            if (idx > -1) {
              let teamMessages;
              if (peerMsgs.length > 1) {
                teamMessages = {
                  ...state.unread_messages[ownerGuid],
                  [peerJid]: [
                    ...peerMsgs.slice(0, idx),
                    ...peerMsgs.slice(idx + 1),
                  ],
                };
              } else {
                const {
                  [peerJid]: peerMessages,
                  ...otherPeerMessages
                } = state.unread_messages[ownerGuid];
                teamMessages = otherPeerMessages;
              }

              return {
                ...state,
                unread_messages: {
                  ...state.unread_messages,
                  [ownerGuid]: teamMessages,
                },
              };
            }
          }
          return state;
        }
        case ActionTypes.UNREAD_MESSAGES_RESET_PEER: {
          const { peerJid, ownerGuid } = action.payload;
          if (
            state.unread_messages[ownerGuid] &&
            state.unread_messages[ownerGuid][peerJid]
          ) {
            const {
              [peerJid]: peerMessages,
              ...otherPeerMessages
            } = state.unread_messages[ownerGuid];
            return {
              ...state,
              unread_messages: {
                ...state.unread_messages,
                [ownerGuid]: otherPeerMessages,
              },
            };
          }
          return state;
        }
        case ActionTypes.UNREAD_MESSAGES_RESET_TEAM: {
          const { ownerGuid } = action.payload;
          if (state.unread_messages[ownerGuid]) {
            const {
              [ownerGuid]: teamMessages,
              ...otherTeamMessages
            } = state.unread_messages;
            return {
              ...state,
              unread_messages: {
                ...otherTeamMessages,
              },
            };
          }
          return state;
        }
        default:
          return state;
      }
    } catch (error) {
      console.error(
        `Error in message reducer: ${error.message || error.code || error}`,
        error
      );
    }
    return state;
  };
};



// WEBPACK FOOTER //
// ./src/reducers/restricted/message.js